import videojs from 'video.js';

const _segments = new WeakMap();

class ReportingTimelineSegments extends videojs.getPlugin('plugin') {
    /**
     *
     * @param {videojs.Player} player
     * @param {Object} options
     */
    constructor(player, options) {
        super(player, options);

        this.segments = [];
    }

    set segments(segments) {
        _segments.set(this, segments);
    }

    get segments() {
        return _segments.get(this);
    }

    addSegment(start, end) {
        const segmentsArray = this.segments;
        segmentsArray.push({ start, end });
        this.segments = segmentsArray;
    };

    getAllSegments() {
        const segments = this.segments;
        let result = [];
        let i;
        for (i = 0; i < segments.length; i += 1) {
            result.push(this.cloneSegment(segments[i]));
        }
        return result;
    };

    cloneSegment(segment) {
        const start = segment.start;
        const end = segment.end;
        return { start: start, end: end };
    }

    reset() {
        this.segments = [];
    };
}

export default ReportingTimelineSegments